module.exports = __webpack_public_path__ + "img/copper.74abb5a4.svg";